import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const UploadFilesErrorMessageWrapper = styled.ul`
  margin-top: ${Spacing.S8};
  list-style-type: disc;
`

export const UploadFileErrorItem = styled.li`
  margin-bottom: ${Spacing.S4};
`
